<script>
  import GbtaFileUploadDialog from './GbtaFileUploadDialog.svelte';
  import {matchBidsUsingPropCodes} from './gbta-file-upload-matchers';
  import {mainAPI} from 'root/angular-injector-provider';

  export let cancel, hide, bids = [], actionResultHandler = () => {};

  const title = `Re-upload Negotiation Response${bids.length > 1 ? 's' : ''}`;

  async function upload(bid, data){
    const actionReport = await mainAPI().negotiations.add(bid._id, data);
    actionResultHandler.handleActionResult(actionReport, [bid]);
  }

</script>

<GbtaFileUploadDialog
  cancel={cancel}
  hide={hide}
  matchFn={matchBidsUsingPropCodes(bids, ['SABRE_PROPCODE', 'INTERNALHOTELCODE', 'PROPCODE'])}
  uploadFn={upload}
>
  <div slot="title">{title}</div>
  <div slot="description">
    <div>Upload a GBTA-compatible Excel or CSV file to resend Hotel RFP Negotiation responses. The file must have GBTA question IDs as headers. A message to the buyer can be added by adding a custom column marked "MESSAGE" as a header.</div>
    <div>Rows in the uploaded file are matched with bids based on the value in the "SABRE_PROPCODE", "INTERNALHOTELCODE", or "PROPCODE" column. The code in the "PROPCODE" column should be the ReadyBid property code, which is available from the GBTA or the Bid Manager export.</div>
  </div>
</GbtaFileUploadDialog>
